import { useEffect } from "react";

import Pulse from "../Pulse";
import "./index.sass";

interface PageProps {
  step: number;
  setStep: (value: number) => void;
}

const Page = ({ step, setStep }: PageProps) => {
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (step === 1) interval = setInterval(() => setStep(step + 1), 1000);
    if (step === 2) interval = setInterval(() => setStep(step + 1), 600);
    if (step === 4) interval = setInterval(() => setStep(step + 1), 800);
    if (step === 5) interval = setInterval(() => setStep(step + 1), 500);
    if (step === 6) interval = setInterval(() => setStep(step + 1), 500);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [step]);

  const handleNext = () => setStep(4);

  return (
    <div className="page-2">
      {step < 5 && (
        <>
          <div className={`page-2-step-1 ${step >= 1 && step < 4 ? "show" : "hide"}`}>
            <div className="page-2-title">Whenever you see the icon below, it means you need to interact with our demo.</div>
          </div>
          <div className={`page-2-step-1 ${step >= 2 && step < 4 ? "show" : "hide"}`}>
            <div className="page-2-title-2">Let's do a quick test! Try tapping the icon.</div>
          </div>
          <div
            onClick={handleNext}
            className={`page-2-step-1 ${step >= 3 && step < 4 ? "show" : "hide"}`}
            style={{ marginTop: "var(--height-40)" }}
          >
            <Pulse style={{ width: "var(--width-180)" }} />
          </div>
        </>
      )}
      {step >= 5 && (
        <div className={`page-2-step-1 ${step > 5 ? "show" : "hide"}`}>
          <div className="page-2-title-2">Great! Now you're ready to explore this demo.</div>
        </div>
      )}
    </div>
  );
};

export default Page;
